import { BriefcaseIcon } from 'vue-feather-icons'

export default [{
  title: 'Ib-pannel',
  route: 'ib-dashbord',
  icon: BriefcaseIcon,
}]
